import React, { useState, useEffect } from "react";
import { getSacivDetails, updateSachivDetails } from "../../api/User";

import { ToastContainer, toast } from "react-toastify";

const SNOProfile = () => {
  const [update, setUpdate] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  // const user_id = sessionStorage.getItem("user_id");
  const user_id = 2;
  const token = sessionStorage.getItem("token");
  const [sachivDetails, setSachivDetails] = useState([]);
  const [imageSrc, setImageSrc] = useState("");
  const phoneRegex = /^[6-9][0-9]{9}$/;
  const [errors, setErrors] = useState({
    name: "",
    mobile_number: "",
    email: "",
    address: "",
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


  const handleUpdate = () => {
    setUpdate(true);
  };

  const fetchData = async () => {
    try {
      const res = await getSacivDetails(token, user_id);
      setSachivDetails(res.data.result[0]);
      setImageSrc(
        `data:image/jpeg/png/jpg;base64, ${res.data.result[0].gram_sachiv_photo_base64}`
      );
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSachivDetails({ ...sachivDetails, file: file });
      setImagePreview(URL.createObjectURL(file));
    }
  };
  const handleCancelUpdate = () => {
    setUpdate(false);
    setImagePreview(null);
    setErrors({});
    window.location.reload();
  };
  const validateField = (field, value) => {
    switch (field) {
      case "name":
        if (!value || value == "") return "Name is required.";
        return "";
      case "mobile_number":
        if (!value || !phoneRegex.test(value))
          return "Invalid mobile number format.";
        return "";
      case "email":
        if (!value || value == "" || !emailRegex.test(value)) return "Invalid email number format.";
        return "";
      case "address":
        if (!value || value == "") return "Address is required.";
        return "";
      default:
        return "";
    }
  };

  //   const handleSave = async () => {
  //     const newErrors = validateInputs();

  //     if (Object.keys(newErrors).some((key) => newErrors[key] !== "")) {
  //       setErrors(newErrors);
  //       toast.error("Please fill all the  required fields.");

  //       return;
  //     }

  //     try {
  //       const formData = new FormData();
  //       formData.append("user_id", user_id);
  //       Object.keys(sachivDetails).forEach((key) => {
  //         formData.append(key, sachivDetails[key]);
  //       });

  //       const res = await updateSachivDetails(token, formData);
  //       toast.success(res.message);
  //       setUpdate(false);
  //       setImagePreview(imagePreview !== null ? imagePreview : null);
  //       fetchData();
  //       setErrors({});
  //       window.location.reload()
  //     } catch (error) {
  //       console.error("Error updating profile:", error);
  //     }
  //   };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const errorMessage =
      value.trim() === ""
        ? "This field cannot be empty"
        : validateField(id, value);
    setSachivDetails({
      ...sachivDetails,
      [id]: [value],
    });
    setErrors({
      ...errors,
      [id]: errorMessage,
    });
  };
  const validateInputs = () => {
    const newErrors = {};
    Object.keys(sachivDetails).forEach((key) => {
      newErrors[key] = validateField(key, sachivDetails[key]);
    });
    return newErrors;
  };

  return (
    <div
      className="container-fluid"
      style={{ background: "#fff", overflowX: "hidden" }}
    >
      <h2 className="" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold", marginLeft: "1.5%" }}>State Nodal Officer</h2>
      <div style={{
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      margin: "16px"
    }}>
      <div
        className="container-fluid"
        style={{ background: "#fff", overflowX: "hidden" }}
      >

        <div className="row ">
          <div className="col-md-12">
            <form className="row g-3 mt-5">
              <div className="col-md-4">
                <label
                  htmlFor="name"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="name"
                  defaultValue={sachivDetails.name}
                  disabled={!update}
                  style={{ textTransform: "uppercase" }}
                  onChange={handleChange}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="mobile_number"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.mobile_number ? "is-invalid" : ""
                    }`}
                  id="mobile_number"
                  defaultValue={sachivDetails.mobile_number}
                  disabled={!update}
                  onChange={handleChange}
                  maxLength={10}
                />
                {errors.mobile_number !== "" && (
                  <div className="invalid-feedback">{errors.mobile_number}</div>
                )}
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="email"
                  className="form-label"
                  style={{ fontWeight: "bold" }}
                >
                  Email ID <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="email"
                  defaultValue={sachivDetails.email}
                  disabled={!update}
                  onChange={handleChange}
                />
                {errors.email !== "" && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              {/* <div className="col-md-6">
              <label
                htmlFor="designation"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Designation <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="designation"
                defaultValue={sachivDetails.designation}
                disabled
                onChange={handleChange}
              />
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="address"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Address <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.address ? "is-invalid" : ""}`}
                id="address"
                defaultValue={sachivDetails.address}
                disabled={!update}
                style={{ textTransform: "uppercase" }}
                onChange={handleChange}
              />
              {errors.address !== "" && (
                <div className="invalid-feedback">{errors.address}</div>
              )}
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="block"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Block <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="block"
                defaultValue={sachivDetails.block}
                disabled
                onChange={handleChange}
              />
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="gram_panchayat_name"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Gram Panchayat Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="gram_panchayat_name"
                defaultValue={sachivDetails.gram_panchayat}
                disabled
                onChange={handleChange}
              />
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="panchayat_website"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Panchayat Website (if any){" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="panchayat_website"
                defaultValue={sachivDetails.panchayat_website}
                disabled={!update}
                onChange={handleChange}
              />
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="other_website"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                If Any Other Website (optional)
              </label>
              <input
                type="text"
                className="form-control"
                id="other_website"
                defaultValue={sachivDetails.other_website}
                disabled={!update}
                onChange={handleChange}
              />
            </div> */}

              {/* <div className="col-md-6">
              <label
                htmlFor="photograph"
                className="form-label"
                style={{ fontWeight: "bold" }}
              >
                Upload Photograph <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="file"
                className="form-control"
                id="photograph"
                accept="image/*"
                disabled={!update}
                onChange={handleImageUpload}
              />
            </div> */}
            </form>
          </div>

          <div className="col-md-12">
            {/* <div
            className="profile-image"
            style={{
              marginLeft: "50px",
              marginTop: "20px",
              overflow: "hidden",
              borderRadius: "50%",
              height: "35vh",
              width: "35vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Profile Preview"
                className="img-fluid"
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <img
                src={imageSrc}
                alt="Profile Preview"
                className="img-fluid"
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            )}
          </div> */}
            <div className="d-flex justify-content-end mt-3">
              {!update ? (
                <button
                  type="button"
                  className="btn"
                  onClick={handleUpdate}
                  style={{
                    width: "12%",
                    backgroundColor: "#4763E430",
                    color: "#4763E4",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }}
                >
                  Update Profile
                </button>

              ) : (
                <>
                  <button
                    type="button"
                    className="btn me-2"
                    // onClick={handleSave} 
                    style={{
                      width: "120px",
                      height: "50px",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      border: "none",
                      padding: "12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      marginBottom: "10px",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#4763E4";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#4763E430";
                      e.target.style.color = "#4763E4";
                    }}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn"
                    onClick={handleCancelUpdate}
                    style={{
                      width: "120px",
                      height: "50px",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      border: "none",
                      padding: "12px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#4763E4";
                      e.target.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "#4763E430";
                      e.target.style.color = "#4763E4";
                    }}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
    </div>
  );
};

export default SNOProfile;
